// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_f2-0";
export var actionModalContentContainer = "_f2-1";
export var createTagButton = "_f2-2";
export var footerContainer = "_f2-7";
export var fullWidthDivider = "_f2-3";
export var hasCreateTagButton = "_f2-4";
export var noCreateTagButton = "_f2-5";
export var tagsContainer = "_f2-6";
export var tagsModalContentContainer = "_f2-8";